import React from 'react'
import emptyTableIcon from "../../assets/breaking_news.svg"


const EmptyStateComponent = ({textContent}) => {
    return ( 
        <>
        <div className="bg-transparent h-full pt-70 px-4 mt-32 w-full flex justify-center items-center flex-col gap-4">
          <div className=" p-3">
            <img src={emptyTableIcon} alt="search" />
          </div>
          <p className="text-base font-medium text-secondary1">
            {" "}
            {textContent}
          </p>
        </div>
        </>
     );
}
 
export default EmptyStateComponent;